<template>
  <div class="sidebar-nav-beauty-services row">
    <SidebarNavItem :item="beautyServices" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CategoriesDataTransformer from '@/data/booking-service/CategoriesDataTransformer.js'
import SidebarNavItem from './SidebarNavItem.vue'
import { dynamicLoadStore } from '@/mixins/store-util'
import bookingService from '@/store/modules/booking-service'

const { mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'SidebarNavBeautyServices',
  components: {
    SidebarNavItem
  },
  mixins: [
    dynamicLoadStore({ bookingService })
  ],
  computed: {
    ...mapState(['categories']),
    beautyServices () {
      const filteredCategories = this.categories.filter(category =>
        !(
          (category.attributes['booking-vendor'] === 'In House' &&
          category.attributes['cutover-from'] === null &&
          category.attributes['cutover-till'] === null) ||
          category.attributes['activity-type'] !== 'Service'
        ) && category.attributes['status'] === 'published'
      )
      return {
        name: this.$t('retailStore.services'),
        path: 'booking-service-index',
        gaTrackingClass: 'ga-olr-bs-link',
        children: new CategoriesDataTransformer(filteredCategories).transformedData
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@include media-breakpoint-down(md) {
  .sidebar-nav-stores-and-events {
    border-bottom: 2px solid $grey-light;
    margin-bottom: 10px;
  }

  .row {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
</style>
